import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add_big",
  "use": "add_big-usage",
  "viewBox": "0 0 75 75",
  "content": "<symbol viewBox=\"0 0 75 75\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"add_big\">\r\n<polygon points=\"75,36 39,36 39,0 36,0 36,36 0,36 0,39 36,39 36,75 39,75 39,39 75,39 \" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol